import { TextField } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { getAvailableSkuOptions, getNotificationProductFilterData, } from '../../services/notificationService';
import './NotificationAdditionalComponents.css';
import GenricMultiSelect from '../Input/GenericMultiSelect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlus, faTrash } from '@fortawesome/free-solid-svg-icons';

const NotificationAdditionalComponents = (props:{additionalNotificationData:React.MutableRefObject<any>, feature:string})=>{
    switch(props.feature){
        case "skuSelection": return (
            <NotificationSkuSelection additionalNotificationData={props.additionalNotificationData}/>
        );
        case "CategoryWiseProduct": return (
            <NotificationProductFiltersSelection additionalNotificationData={props.additionalNotificationData}/>
        );
        default: return (<></>);
    }
}

const NotificationSkuSelection = (props:{additionalNotificationData:React.MutableRefObject<any>})=>{

    const [skuOptions, setSkuOptions] = useState<string[]>([]);
    const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
    const [selectedSkus, setSelectedSkus] = useState<string[]>([]);
    const [noOptionsMessage, setNoOptionsMessage] = useState<string>("Enter 4 characters to search" )
    const allAvailableSkus = useRef<string[]>([]);
    useEffect(()=>{
        const getAndSetSkuData = async ()=>{
            const productData = await getAvailableSkuOptions();
            allAvailableSkus.current = productData;
            setSkuOptions(productData.slice(0, 100));
        }
        getAndSetSkuData()
    },[])

    const handleSkuSelect = (selectedOptions: string[])=>{
        setSelectedOptions(selectedOptions)
    }

    const removeSelectedSkus = (skuOptionsArray:string[])=>{
        const updatedOptions = skuOptionsArray.filter(option=>!selectedSkus.includes(option));
        return updatedOptions;
    }

    const handleAddSelectedSkus = ()=>{
        const newSelectedSkus = [...selectedSkus,...selectedOptions];
        setSelectedSkus(newSelectedSkus);
        setSelectedOptions([]);
        const updatedSkuOptions = allAvailableSkus.current.filter(skuCode=>!newSelectedSkus.includes(skuCode)).slice(0,100);
        setSkuOptions(updatedSkuOptions);
    }

    const onSkuInputChange = (event:any)=>{
        const inputValue:string = event?.target?.value ? event?.target?.value.toLowerCase() : null;
        if(!inputValue ){
            const optionsToShow = removeSelectedSkus(allAvailableSkus.current).slice(0, 100)
            setSkuOptions(optionsToShow);
            setNoOptionsMessage("No Data")
            return;

        }
        if(inputValue.length<4){
            setNoOptionsMessage("Enter 4 characters to search")
            setSkuOptions([]);
            return;
        }
        setNoOptionsMessage("No Data")
        const availableOptions = removeSelectedSkus(allAvailableSkus.current.filter(skuCode=>skuCode.toLowerCase().includes(inputValue))).slice(0, 100)
        setSkuOptions(availableOptions)
        return;
    }

    const updateQty = (skuCode:string, key:string, value:string)=>{
        props.additionalNotificationData.current[skuCode][key] = value;
    }

    const removeSkuCode = (skuCode:string)=>{
        delete props.additionalNotificationData.current[skuCode];
        const newSelectedSkus = selectedSkus.filter(sku=>sku!==skuCode);
        setSelectedSkus(newSelectedSkus);
    }

    return (
        <>
            <div className='sku-selection-field'>
                <div className='sku-select-input-field'>
                    <GenricMultiSelect 
                        onInputChange={onSkuInputChange}
                        label={"SKU"}
                        options={skuOptions}
                        selectedOptions={selectedOptions}
                        handleMultiSelectState = {handleSkuSelect}
                        isRequired = {false}
                        noOptionMessage = {noOptionsMessage}
                        params={{size:"small"}}
                    />
                </div>
                <FontAwesomeIcon
                    onClick={handleAddSelectedSkus}
                    className="notification-sku-add-icon"
                    icon={faCirclePlus}
                />
            </div>
            <div className={"notification-sku-container"}>
                { selectedSkus.map(skuCode=>{
                    props.additionalNotificationData.current[skuCode] = props.additionalNotificationData.current[skuCode] ?? {
                        'piece':'0',
                        'case':'0'
                    }
                    return(
                        <div className='sku-fields-container' key={skuCode}>
                            <TextField
                                className='sku-code-display-field'
                                size="small"
                                value={skuCode}
                                label={"SKU Code"}
                                disabled={true}
                            />
                            <TextField
                                className='sku-code-field'
                                size="small"
                                type="number"
                                onChange={(event)=>{
                                    updateQty(skuCode,'case',event.target.value);
                                }}
                                defaultValue='0'
                                label={"Case"}
                            />
                            <TextField
                                className='sku-code-field'
                                size="small"
                                type="number"
                                onChange={(event)=>{
                                    updateQty(skuCode,'piece',event.target.value);
                                }}
                                defaultValue='0'
                                label={"Piece"}
                            />
                            <FontAwesomeIcon
                                onClick={()=>{removeSkuCode(skuCode)}}
                                className="notification-sku-add-icon"
                                icon={faTrash}
                            />
                        </div>
                    );
                })
                }
            </div>
        </>
    );
}

export interface NotificationProductFilter {
    key:string;
    label: string;
    options: string[];
}

const NotificationProductFiltersSelection = (props:{additionalNotificationData:React.MutableRefObject<any>})=>{

    const filtersToShow:NotificationProductFilter[] = [
        {
            key:"category",
            label:"Category Name",
            options:[]
        },
        {
            key:"pieceSize",
            label:"Pack Size",
            options:[]
        },
        {
            key:"brand",
            label:"Brand",
            options:[]
        }
    ]

    const defaultSelectedOptions:{[key:string]:string[]} = {};
    filtersToShow.forEach(filter=>{
        defaultSelectedOptions[filter.key] = [];
    })

    const [selectedFilterOptions, setSelectedFilterOptions] = useState<{[key:string]:string[]}>(defaultSelectedOptions)

    const [productFilterData, setProductFilterData] = useState<NotificationProductFilter[]>(filtersToShow)

    useEffect(()=>{
        filtersToShow.forEach(filter=>{
            props.additionalNotificationData.current[filter.key] = [];
        })
    },[])

    useEffect(()=>{
        const updateProductFilterData = async ()=>{
            const newProductFilterData:NotificationProductFilter[] = await getNotificationProductFilterData(productFilterData,selectedFilterOptions)
            setProductFilterData(newProductFilterData)
        }
        updateProductFilterData();
        
    },[selectedFilterOptions])

    const handleFilterSelect = (selectedOptions:string[], key:string)=>{

        const updatedSelectedOptions = {...selectedFilterOptions};
        props.additionalNotificationData.current[key] = selectedOptions;
        updatedSelectedOptions[key] = selectedOptions;
        setSelectedFilterOptions(updatedSelectedOptions);
    }

    return (
        <div className='notification-product-filter-container'>
            {productFilterData.map(filterData=>{
                return(
                    <GenricMultiSelect
                        className='notification-product-filter-input'
                        label={filterData.label} 
                        options={filterData.options}
                        selectedOptions={selectedFilterOptions[filterData.key]}
                        handleMultiSelectState = {(selectedOptions:string[])=>{handleFilterSelect(selectedOptions,filterData.key)}}
                        isRequired = {false}
                        noOptionMessage = "No Data" 
                        params={{size:"small", disableClearable:false}}
                    />
                );
            })}
        </div>
    );
}

export default NotificationAdditionalComponents;